import { MenuLeaf } from '../../../types/types';
import useRoutes from '../../../hooks/useRoutes';

type MenuLeafTarget = {
  routerLink: string;
  navKey: string;
};

// Resolves a navigable leaf to its route: form leaves open the standalone add
// form, dataset leaves open the dataset list. Returns null for non-navigable leaves.
export const getMenuLeafTarget = (
  menuItem: MenuLeaf,
  routes: ReturnType<typeof useRoutes>
): MenuLeafTarget | null => {
  if (menuItem.formId) {
    return {
      routerLink: routes.formAddAction(menuItem.formId),
      navKey: menuItem.formId,
    };
  }

  if (menuItem.appId && menuItem.app) {
    return {
      routerLink: routes.application(menuItem.appId),
      navKey: `app:${menuItem.appId}`,
    };
  }

  if (menuItem.url) {
    return {
      routerLink: routes.datasetList(menuItem.url),
      navKey: menuItem.url,
    };
  }

  return null;
};
